import { CacheService } from 'web_core_library';
import { IAssetCacheValue } from './types';

let cacheBasePathPrefix: string;

async function init(basePath: string) {
  cacheBasePathPrefix = basePath;
  await CacheService.init();
}

export const ASSETS_CACHE_EXPIRATION_TIMEOUT = 7 * 24 * 60 * 60 * 1000; // 7 days

export const isCacheValueExpired = <T>(cacheValue?: IAssetCacheValue<T>) => {
  if (!cacheValue) {
    return true;
  }
  const current = Date.now();
  return current - cacheValue.syncTimestamp >= ASSETS_CACHE_EXPIRATION_TIMEOUT;
};

async function get<T>(assetName: string) {
  let cacheValue: IAssetCacheValue<T> | undefined;
  try {
    cacheValue = await CacheService.load<IAssetCacheValue<T>>(`unity-${cacheBasePathPrefix}-${assetName}`);
    if (isCacheValueExpired(cacheValue)) {
      return;
    }
    return cacheValue?.asset;
  } catch (error) {
    // ignore errors, return undefined as if cache was empty
    return;
  }
}

function set<T>(assetName: string, asset: T) {
  try {
    const cacheValue: IAssetCacheValue<T> = {
      asset,
      syncTimestamp: Date.now(),
    };
    return CacheService.save(`unity-${cacheBasePathPrefix}-${assetName}`, cacheValue);
  } catch (error) {
    // ignore errors, cache will not be saved
    return;
  }
}

const UnityCacheService = {
  get,
  init,
  set,
};
export default UnityCacheService;
